import React from "react";
import { Drawer, List, Tag, Button, Space, Spin } from "antd";
import { VideoCameraOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const statusColors = {
  waiting: "orange",
  active: "green",
  ended: "red",
};

const VideoCallDrawer = ({ open, onClose, calls, userType, loading }) => {
  const navigate = useNavigate();

  const handleJoin = (appointmentId, patientId) => {
    if (userType === "Doctor") {
      navigate("/video-call", { state: { patientId, appointmentId } });
    } else if (userType === "Patient") {
      navigate("/call", { state: { patientId, appointmentId } });
    }
  };

  const renderActionButton = (item) => {
    if (userType === "Doctor") {
      if (item.status === "waiting") {
        return (
          <Button
            type="primary"
            icon={<VideoCameraOutlined />}
            onClick={() => handleJoin(item.appointmentId, item.patientId)}
          >
            Start Call
          </Button>
        );
      } else if (item.status === "active") {
        return (
          <Button
            type="primary"
            icon={<VideoCameraOutlined />}
            onClick={() => handleJoin(item.roomCode, item.patientId)}
          >
            Join
          </Button>
        );
      }
    } else if (userType === "Patient") {
      if (item.status === "waiting") {
        return <Button disabled>Doctor needs to start</Button>;
      } else if (item.status === "active") {
        return (
          <Button
            type="primary"
            icon={<VideoCameraOutlined />}
            onClick={() => handleJoin(item.roomCode, item.patientId)}
          >
            Join
          </Button>
        );
      }
    }
    return (
      <Button danger disabled icon={<CloseCircleOutlined />}>
        Ended
      </Button>
    );
  };

  return (
    <Drawer
      title="Video Calls"
      placement="right"
      onClose={onClose}
      open={open}
      width={360}
    >
      {loading && <Spin />}
      {calls.length === 0 ? (
        <p>No active or waiting calls</p>
      ) : (
        <List
          dataSource={calls}
          renderItem={(item) => (
            <List.Item actions={[renderActionButton(item)]}>
              <List.Item.Meta
                title={
                  <Space>
                    <span>
                      {userType === "Doctor"
                        ? `Patient: ${item?.patientName}`
                        : `Dr. ${item.doctor?.name}`}
                    </span>
                    <Tag color={statusColors[item.status]}>
                      {item.status.toUpperCase()}
                    </Tag>
                  </Space>
                }
                description={`Appointment: ${item.appointmentDate} at ${item.appointmentTime}`}
              />
            </List.Item>
          )}
        />
      )}
    </Drawer>
  );
};

export default VideoCallDrawer;
